
import $global from 'stores/global'
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    disableTooltip: {
      type: Boolean,
      default: false
    },
    teleported: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: undefined
    }
  },
  computed:{
    disable_tooltip(){
      if (this.disableTooltip || !this.text || !this.$responsive.desktop) return true
      return !$global.tooltips_enabled
    }
  }

}
